import React from "react";

const PageContext = React.createContext();

export default PageContext;
